import React from 'react';
import { Autocomplete as MuiAutocomplete } from '@mui/material';
import { AutocompleteLoadingIndicator } from './AutocompleteLoadingIndicator';

export const Autocomplete = MuiAutocomplete;
// @ts-expect-error workaround, it's not possible to set this in defaultProps in theme
Autocomplete.defaultProps = {
  loadingText: <AutocompleteLoadingIndicator />,
};
